export const phoneIsValid = (phone: string): boolean => {
  // eslint-disable-next-line no-useless-escape
  const phoneRegex = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/
  if (phoneRegex.test(phone)) {
    return true
  } else {
    return false
  }
}
